const appConfig = {
    apiPrefix: '/api',
    apiReportsPrefix: '/api',
    apiPrefixServer: 'https://api.kaminosv.com/api',
    //apiPrefixServer: 'http://localhost:3050/api',  
    apiReportsServer: 'https://reports.kaminosv.com/api', //'https://reports.kaminosv.com/api',//'https://localhost:44351/api' , //'https://reports.kaminosv.com/api', //http://localhost:49510/api, 
    authenticatedEntryPath: '/pages/welcome',
    AZURE_STORAGE_CONNECTION_STRING: "DefaultEndpointsProtocol=https;AccountName=ucontrolblob;AccountKey=+rQxrygR38wVj7Xq+f6hNKw93h9QMIYt1auEWYMhEphnvt4DqwEIiJAO8PkntJn0N1onkrmOvkhxCT5tr02Yxw==;EndpointSuffix=core.windows.net",
    AZURE_containername: "kaminostorage",
    storageAccountName: "kaminosv",
    sasToken: "sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-02-18T09:48:51Z&st=2025-02-18T01:48:51Z&spr=https,http&sig=mt5LEFlF3dgbIYz%2FWoFQHpu0%2F%2BfeexpeGdWuzMgT%2BCM%3D",
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig